import { tableInitialState } from '@/components/Table/FullTable/FullTable'
import { isNullish } from '@/utils/helper'
import { camelToWords } from '@/utils/stringHelper'

export const simplifyTableColumns = (tableColumns) => {
  const simplifiedColumns = tableColumns.map((column) => {
    return {
      id: column?.accessorKey ?? '',
      label: camelToWords(column?.accessorKey),
      show: true,
      filterValue: '',
      filterType: column?.meta?.filterVariant ?? 'text',
      filterOptions: column?.meta?.filterOptions ?? [],
    }
  })

  if (simplifiedColumns.some((col) => col.key === '' || col.label === '')) {
    throw new Error('The table columns contain empty key or label')
  }
  return simplifiedColumns
}

export const getTableColumns = (tableDetails, tableColumns, headers = {}) => {
  const columnOrder = tableDetails?.columnOrder ?? []
  const columnFilters = tableDetails?.columnFilters ?? []
  const columnVisibility = tableDetails?.columnVisibility ?? {}

  const simplifiedColumns = tableColumns.map((column) => {
    const showColumn = isNullish(columnVisibility[column.accessorKey]) ? true : columnVisibility[column.accessorKey]
    const filter = columnFilters.find((fil) => fil.id === column.accessorKey)
    return {
      id: column?.accessorKey ?? '',
      label: headers[column?.accessorKey] ? headers[column.accessorKey] : camelToWords(column?.accessorKey),
      show: showColumn,
      filterValue: filter?.value ?? '',
      filterType: column?.meta?.filterVariant ?? 'text',
      filterOptions: column?.meta?.filterOptions ?? [],
    }
  })

  if (simplifiedColumns.some((col) => col.key === '' || col.label === '')) {
    throw new Error('The table columns contain empty key or label')
  }

  if (columnOrder.length > 0) {
    return simplifiedColumns.sort((a, b) => {
      const indexA = columnOrder.indexOf(a.id)
      const indexB = columnOrder.indexOf(b.id)
      return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB)
    })
  }
  return simplifiedColumns
}

export const convertToTableDetails = ({ tableColumns, haveActionButton = false }) => {
  const columnOrder = haveActionButton
    ? ['action', ...tableColumns.map((col) => col.id)]
    : tableColumns.map((col) => col.id)

  let columnVisibility = {}
  tableColumns.forEach((col) => {
    columnVisibility[col.id] = col.show
  })
  const columnFilters = tableColumns
    .filter((col) => {
      if (!columnVisibility[col.id]) return false

      if (Array.isArray(col.filterValue)) {
        return col.filterValue.length > 0
      }

      return col.filterValue !== ''
    })

    .map((col) => ({
      id: col.id,
      value: col.filterValue,
    }))

  if (haveActionButton) {
    columnVisibility.action = true
  }

  return {
    ...tableInitialState,
    columnOrder: columnOrder,
    columnFilters: columnFilters,
    columnVisibility: columnVisibility,
  }
}
